import { Component, OnInit, OnDestroy, PLATFORM_ID, Inject } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
//import 'rxjs/add/operator/catch';
import { take, catchError } from 'rxjs/operators';

// models
import { AppState } from '../../models/app-state.interface';
import { SaveGoogleRequest } from '../../models/save-google-request.interface';
import { LoadingStatusInitState } from '../../../shared/models/loading-status.interface';
import { UpsellBooking } from '../../models/upsell-booking.interface';
// service
import { BookingService } from '../../services/booking.service';
import { CollectionService } from '../../services/collection.service';
import { EventsService } from '../../services/events.service';
import { GeocodeService } from '../../services/map-geocode.service';
import { PriceService } from '../../../booking/services/price.service';
import { CopyService } from '../../../shared/services/app-copy.service';
import { AppStateService } from '../../../shared/services/app-state.service';
import { AirportCopyService } from '../../../shared/services/app-airport-copy.service';
// enum
import { LocationType } from '../../../shared/enum/location-type.enum';
// globals
import { AGM_MAP_STYLE, SLOT_NUMBER } from '../../../shared/globals';
import { AppLoaderService } from '../../../shared/services/app-loader.service';
import { DataStorageService } from '../../../shared/services/data-storage.service';
import { SharedService } from '../../../shared/services/shared-service.service';
import { ErrorHandler } from '../../../shared/services/error-handler.service';
import { FormsModule } from '@angular/forms';
import { sbbSubsidyStatusUpdate, updateCustomerAddress, updateIsAirportToAirport, updateSbbPublicTransportDiscountStatus } from 'app/booking/reducers/booking.actions';
import { updateBookingObject } from 'app/booking/reducers/current-booking.reducer';
import { selectedServiceType, updateInboundAddress, updateOutboundAddress } from 'app/booking/reducers/d2d-booking.reducer';
import { updateFlybackRedirect } from 'app/booking/reducers/flyback.reducer';
import { ResidentialComponent } from 'app/booking/components/location/residential/residential.component';
import { HotelBusinessComponent } from 'app/booking/components/location/hotel-business/hotel-business.component';
import { GoogleMapsService } from '@shared/services/googleMap.service';
import { LanguageSelectorComponent } from '@shared/components/language-selector/language-selector.component';
import { UpsellBookingComponent } from 'app/booking/components/upsell-booking/upsell-booking.component';

declare var ga: any;
declare var exponea: any;
@Component({
  selector: 'app-step-location',
  standalone: true,
  imports: [CommonModule, FormsModule, ResidentialComponent, HotelBusinessComponent, LanguageSelectorComponent, UpsellBookingComponent],
  templateUrl: './step-location.component.html',
  styleUrls: ['./step-location.component.scss'],
  // providers: [GeocodeService, PriceService]
})
export class StepLocationComponent implements OnInit, OnDestroy {

  private _bookingInitSubscription: Subscription;
  private _allAirportsSubscription: Subscription;
  private _userLanguageSubscription: Subscription;
  private _upsellBookingSubscription: Subscription;
  private _d2dBookingSubscription: Subscription;
  private _bookingCarrier;
  private _bookingJourneyReference: string;
  private _bookingProduct: string;
  private _pageViewSent = false;
  private _airlineCode;
  private _firstLoad = true;
  private _subscriptionsSet = false;
  private _bookingState;
  private _bookingStateSubscription: Subscription;
  private _flybackReducerStateSubscription: Subscription
  private _bookingSubscription: Subscription;
  private _geoCoordsValidationSubscription: Subscription;

  public bookingInit: Boolean = false;
  public bookingState: any;
  public currentBooking: any;
  public bookingProduct: string;
  public bookingType: string;
  public userAddresses: Array<any>;
  public flightDirection: Number;
  // public postcodeData: any;
  // public postcodesLoaded: Boolean = false;
  public airportsLoaded: Boolean = false;
  public saveLocationRequest: SaveGoogleRequest;
  public selectedLocationType = 4;
  public airportData: any;
  public residentialGeoCoords = null;
  public showMenu = true;
  public locationItems = [
    {
      type: 'Residential',
      value: 4
    },
    {
      type: 'Hotel',
      value: 2
    },
    // {
    //   type: 'Airport',
    //   value: 8
    // }
  ];
  public activeRadioIndex = 0;
  public mapStyles = AGM_MAP_STYLE;
  public selectedLanguage = '';
  public appCopy;
  public appAirportCopy;
  public upsellbookingStatus: UpsellBooking = {} as UpsellBooking;
  public isSbbSubsidyApplied: boolean = false;
  public isSbbSubsidyAvailable: boolean = false;
  public airportName: string = '';
  public flightData: any;
  public isHubdropBooking;
  public canBeHubdropBooking: boolean = false;
  public oldBooking: any;
  public addressPostCodeRes:any;
  public flyback: boolean = false;
  public flyBackRedirect: boolean = false;
  public isGeoCoordValid: boolean = false;
  public subscriptionSet: boolean = false;

  constructor(
    private _appStore: Store<AppState>,
    private _router: Router,
    private _errorService: ErrorHandler,
    private _activatedRoute: ActivatedRoute,
    private _collectionService: CollectionService,
    private _bookingService: BookingService,
    private _dataStorageService: DataStorageService,
    private _eventsService: EventsService,
    private _geocodeService: GeocodeService,
    private _sharedService: SharedService,
    private _priceService: PriceService,
    private _copyService: CopyService,
    private _appStateService: AppStateService,
    private _airportCopyService: AirportCopyService,
    private _appLoaderService: AppLoaderService,
    private _GoogleMapsService: GoogleMapsService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {

    if (isPlatformBrowser(this.platformId)) {
      exponea.track('address_selection_load',{
        'A/B test': this._sharedService.getCurrentSlotNumber()
      });
    }
    this._router.navigate([], { replaceUrl: true, queryParams: {}, relativeTo: this._activatedRoute });

    const state = this.getState(this._appStore);
    const flybackReducer = state.flybackReducer
    const flyBack = flybackReducer.flybackBooking
    const flyBackRedirect = flybackReducer.flyBackRedirect

    if(flyBack && !flyBackRedirect) {
      this._appLoaderService.showLoader('We are creating your booking!', false, true);
    }

    this._copyService.getStaticCopy();
    this._airportCopyService.getStaticCopy();
    this._bookingStateSubscription = this._appStore.select('bookingReducer')
      .subscribe((bookingState: any) => {
        this._bookingState = <AppState>bookingState;
        this.isSbbSubsidyApplied = this._bookingState.bookingDetails.isSbbSubsidyApplied;
        this.isSbbSubsidyAvailable = this._bookingState.bookingDetails.isSbbSubsidyAvailable;
      });

    this._flybackReducerStateSubscription = this._appStore.select('flybackReducer')
      .subscribe((flybackReducer: any) => {
        this.flyback = flybackReducer.flybackBooking;
        this.flyBackRedirect = flybackReducer.flyBackRedirect;
      });

    this._geoCoordsValidationSubscription = this._collectionService.geoCoordsSubject$
      .subscribe(e => {
          if(e.response.isGeoCoordValid) {
              if(this.flyback && !this.flyBackRedirect) {
                const oldBookingInfoReducer = this.oldBooking.abcBooking.currentBookingReducer.currentBooking;
                const collectionLocation = oldBookingInfoReducer.bookingJourney[0].collectionLocation
                const addressPostCode = oldBookingInfoReducer.bookingJourney[0].collectionLocation.addressPostCode;
                this.validateAndProcessPostcode(addressPostCode)
              .then(() => {
                // if ssb is available and applied then set into currentBooking reducer
                this._appStore.dispatch(sbbSubsidyStatusUpdate({ payload: this.oldBooking.abcBooking.bookingReducer.bookingDetails.isSbbSubsidyAvailable }));
                this._appStore.dispatch(updateSbbPublicTransportDiscountStatus({ payload: this.oldBooking.abcBooking.bookingReducer.bookingDetails.isSbbSubsidyApplied }));
                this.flybackRedirection(collectionLocation);
                // console.log('Postcode validated and page processed.');
              })
              .catch((error) => {
                this._appLoaderService.hideLoader();
                this._errorService.handleCustomError({ text: this.addressPostCodeRes.data.validationErrorMessages[0].reasons[0], sticky: false });
                console.error('Error processing postcode:', error);
                return;
              });
              }
              setTimeout(() => {
                this.showMiniMap();
              }, 500);

          } else {
            this._appStore.dispatch(updateFlybackRedirect({ payload: true }));
          }
      });

    this._bookingInitSubscription = this._appStore.select('loadedStatusReducer')
      .subscribe((res: any) => {
        // if booking data has bookingLoaded
        // show template and subscribe to data
        if (res.currentBookingLoaded && res.userLoaded && res.airportLocationsLoaded && this._firstLoad && !this._subscriptionsSet && res.copyLoaded && res.airportCopyLoaded) {
          this._firstLoad = false;

          if(!this._bookingSubscription){
            this._bookingSubscription = this._appStore.select('oldBookingInfoReducer')
            .subscribe((booking: any) => {
              if(this.flyback) {

                this.oldBooking = booking;
                const flightData = booking.abcBooking?.flightReducer.flightDetails.flightResponse.flightStatusDetails[0];
                const airlineCode = flightData.airlineCode;
                const airportCode = flightData.departureAirport.airportCode;
                const geoCoord = booking.abcBooking?.currentBookingReducer.currentBooking.bookingJourney[0].collectionLocation.geoCoord;
                if(!this.flyBackRedirect) {
                  // validate the post code before auto submit

                  // if ssb is available and applied then set into currentBooking reducer
                  const oldBookingInfoReducer = this.oldBooking.abcBooking.currentBookingReducer.currentBooking;
                  this._appStore.dispatch(updateBookingObject({ payload: oldBookingInfoReducer }));
                  this._appStore.dispatch(sbbSubsidyStatusUpdate({ payload: this.oldBooking.abcBooking.bookingReducer.bookingDetails.isSbbSubsidyAvailable }));
                  this._appStore.dispatch(updateSbbPublicTransportDiscountStatus({ payload: this.oldBooking.abcBooking.bookingReducer.bookingDetails.isSbbSubsidyApplied }));

                  this._collectionService.validatLocationGeoCoords({ airline: airlineCode, airportCode: airportCode, geoCoord: geoCoord });

                }
                // console.log('oldBookingReducer', booking);
              }

              if(!this.subscriptionSet){
                this.subscriptionSet = true;
                this.setDataSubscriptions();
              }


            });
          }

          if (res.copyLoaded && isPlatformBrowser(this.platformId)) {
            this.getCopy();
          }

          if (res.airportCopyLoaded && isPlatformBrowser(this.platformId)) {
            this.getAirportCopy();
          }

          this.bookingInit = res.currentBookingLoaded;
        } else {
          return;
        }
      });
  }
  showMiniMap() {
    // Wait for the map container to be rendered
    const mapElement = document.getElementById('residentialMap') as HTMLElement;
    if (!mapElement) {
      console.error('Map container not found!');
      return;
    }
    this._GoogleMapsService.load().then(() => {
      const map = new google.maps.Map(document.getElementById('residentialMap') as HTMLElement, {
        center: {
          lat: this.residentialGeoCoords.latitude,
          lng: this.residentialGeoCoords.longitude,
        },
        zoom: 16,
        maxZoom: 16,
        minZoom: 16,
        disableDefaultUI: true, // Disable default UI controls
        styles: this.mapStyles, // Apply custom styles
        scrollwheel: false, // Disable scroll zooming
      });

      // Add marker to the map
      new google.maps.Marker({
        position: {
          lat: this.residentialGeoCoords.latitude,
          lng: this.residentialGeoCoords.longitude,
        },
        map: map,
        icon: 'https://portrlivecdnstorage.blob.core.windows.net/webimages/location.png', // Custom marker icon
      });

    });
  }
  validateAndProcessPostcode(addressPostCode: string): Promise<void> {
    return new Promise((resolve, reject) => {
      // Call validatePostcode
      this._sharedService.validatePostcode(addressPostCode, (res) => {
        this.addressPostCodeRes =  res;
        if (res.data.isPostCodeValid) {
          resolve(); // Resolve the promise after the reload
        } else {
          reject('Postcode is invalid'); // Reject the promise if postcode is invalid
        }
      });
    });
  }

  getAirportCopy() {
    this.appAirportCopy = this._airportCopyService.getAirportsCopy();
  }

  setDataSubscriptions() {
    this.setCurrentStoreVars();

    // this._collectionService.getPostCodes();
    this._bookingService.getAirportData();

    // get Airports list
    this._allAirportsSubscription = this._bookingService.getAllAirports$
      .pipe(take(1))
      .subscribe(res => {
        this.airportData = res;
        this.airportsLoaded = true;
      });

    // if location already set in booking
    // auto-select appropriate tab
    if (this.flightDirection === 1 && this.currentBooking.bookingCompletion.collectionLocationDetails) {
      this.selectedLocationType = this.currentBooking.bookingJourney[0].collectionLocation.type;
      this.radioToggleChange(this.locationItems.findIndex(item => item.value === this.selectedLocationType));
      this.showMenu = false;
    } else if (this.flightDirection === 2 && this.currentBooking.bookingCompletion.deliveryLocationDetail) {
      this.selectedLocationType = this.currentBooking.bookingJourney[0].deliveryLocation.type;
      this.radioToggleChange(this.locationItems.findIndex(item => item.value === this.selectedLocationType));
      this.showMenu = false;
    }

    this._upsellBookingSubscription = this._appStore.select('upsellBookingReducer')
      .subscribe(res => {
        this.upsellbookingStatus = res;
      });

    this._d2dBookingSubscription = this._appStore.select('d2dReducer')
      .subscribe((res) => {
        const outboundBooking = res.outboundBooking;
        const selectPostOffice = outboundBooking?.hubDropReducer?.selectedPostOffice;
        if (selectPostOffice && outboundBooking.hubDropReducer.selectedCollectionType === 'atPostOffice') {
          this.isHubdropBooking = true;
        }
      });

    // send GA events
    if (this.bookingType !== 'amend' && !this._pageViewSent) {
      if (this._bookingProduct === 'abc') {
        ga('set', 'page', '/' + this._bookingProduct + '/collection-location/' + this._airlineCode);
      } else {
        // check product type
        ga('set', 'page', '/' + this._bookingProduct + '/collection-location');
      }
      ga('send', 'pageview');
      this._pageViewSent = true;
    } else {
      ga('set', 'page', '/a/' + this._bookingProduct + '/collection-location');
      ga('send', 'pageview');
      this._pageViewSent = true;
    }

    this._subscriptionsSet = true;

  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }

  // set booking state to vars
  setCurrentStoreVars() {
    const currentAppState: any = this.getState(this._appStore);
    // booking store vars
    this.bookingState = currentAppState.bookingReducer;
    this.bookingProduct = this.bookingState.bookingDetails.bookingProduct;
    // user saved addresses
    this.userAddresses = currentAppState.userReducer.userDetails.userAddresses;
    // current booking store vars
    this.currentBooking = currentAppState.currentBookingReducer.currentBooking;
    // booking vars
    this.flightDirection = this.bookingState.bookingDetails.journeyLegDetails[0].journeyDirection;
    this.bookingType = this.bookingState.bookingDetails.bookingType;
    this._bookingJourneyReference = this.bookingState.bookingDetails.bookingJourneyReference;
    this._bookingProduct = this.bookingState.bookingDetails.bookingProduct;
    this._airlineCode = currentAppState.flightReducer.flightDetails.flightResponse.flightStatusDetails[0].airlineCode;

    this.flightData = currentAppState.flightReducer.flightDetails.flightResponse;
    this.canBeHubdropBooking = this.flightData.flightStatusDetails[0].departureAirport.airportCode === 'ZRH' && this.flightData.flightStatusDetails[0].airlineCode === 'LX';
    const bookingProduct = currentAppState.bookingReducer.bookingDetails.bookingProduct;

    const containsManchester = this.flightData.flightStatusDetails[0].departureAirport.airportCode === 'MAN'
      || this.flightData.flightStatusDetails[this.flightData.flightStatusDetails.length - 1].arrivalAirport.airportCode === 'MAN';

    const containsGVA = (this._bookingProduct === 'abc' && this.flightData.flightStatusDetails[0].departureAirport.airportCode === 'GVA')
      || (this._bookingProduct === 'ccd' && this.flightData.flightStatusDetails[this.flightData.flightStatusDetails.length - 1].arrivalAirport.airportCode === 'GVA');

    const containsZurich = (this._bookingProduct === 'abc' && this.flightData.flightStatusDetails[0].departureAirport.airportCode === 'ZRH')
      || (this._bookingProduct === 'ccd' && this.flightData.flightStatusDetails[this.flightData.flightStatusDetails.length - 1].arrivalAirport.airportCode === 'ZRH');

    // const isDepartFromGVA = this.flightData.flightStatusDetails[0].departureAirport.airportCode === 'GVA';
    // const isArrivalFromGVA = this.flightData.flightStatusDetails[0].arrivalAirport.airportCode === 'GVA';
    // const isDepartFromZRH = this.flightData.flightStatusDetails[0].departureAirport.airportCode === 'ZRH';
    // const isArrivalFromZRH = this.flightData.flightStatusDetails[0].arrivalAirport.airportCode === 'ZRH';

    // if flight departs/arrives to Manchester, Geneva, Zurich remove Airport tab
    if (containsManchester || containsGVA || containsZurich) {
      this.locationItems = this.locationItems.filter(location => location.type !== 'Airport');
    }

    const flightBookingData = {
      departureAirportCode: this.flightData.flightStatusDetails[0].departureAirport.airportCode,
      flightInfoId: this.flightData.flightInfo.id,
      requestFlightNumber: this.flightData.flightInfo.requestFlightNumber,
      airportCityName: this.flightData.flightStatusDetails[0].departureAirport.airportCityName,
      flightLeg: 1,
      requestDepartureDate: this.flightData.flightStatusDetails[0].departureDateTimeDetails.scheduledDateTimeLocal
    };
    // changes done for 9488 & 9651 && 9781
    if ((currentAppState.flightReducer.flightDetails.flightResponse.totalNumberOfLegs > 1 || currentAppState.flightFinderReducer.requestLegs > 1) && currentAppState.bookingReducer.bookingDetails.bookingType === 'new' && currentAppState.flightFinderReducer.selectedMultiLegFlight) {
      flightBookingData.flightInfoId = currentAppState.bookingReducer.bookingDetails.uuid;
    }

    this._bookingService.updateBookingFlight(flightBookingData);
    const virtualBagClassifications = currentAppState.bookingReducer.bookingDetails.bagItems
    const virtualBagCount = currentAppState.bookingReducer.bookingDetails.virtualBagCount
    this._appStateService.setBagItems(virtualBagClassifications);
    this._appStateService.setVirtualBags(virtualBagCount);
    this._bookingService.updateBagItems(virtualBagClassifications);
    this._bookingService.updateVirtualBags(virtualBagCount);

    if (this.getState(this._appStore).bookingReducer.bookingDetails.virtualBagCount === 0 && this.bookingType !== 'amend') {
      const quoteRequest = this.getState(this._appStore).flightFinderReducer.quoteFlightRequest;
      this._appStateService.setBagItems(quoteRequest.bagItems);
      this._appStateService.setVirtualBags(quoteRequest.bagCount);

      this._bookingService.updateBagItems(quoteRequest.bagItems);
      this._bookingService.updateVirtualBags(quoteRequest.bagCount);
    }

    this._bookingService.updateAirportTime(
      this.flightDirection,
      this.flightData.flightStatusDetails[0].departureDateTimeDetails.scheduledDateTimeLocal
    );

    this._bookingCarrier = this.bookingState.bookingDetails.carrier.airlineCode;
    this._userLanguageSubscription = this._appStore.select('copyReducer')
      .subscribe((res: any) => {
        this.selectedLanguage = res.language;
      })

    if (this.flightDirection === 1) {

      this._bookingService.updateAirportLocation(
        this.flightDirection,
        this.flightData.flightStatusDetails[0].departureAirport.airportCode,
        this.flightData.flightStatusDetails[0].departureAirport.airportTerminal
      );
      this._bookingService.updateBookingFlagsDeliveryLocation(true);

    } else if (this.flightDirection === 2) {

      this._bookingService.updateAirportLocation(
        this.flightDirection,
        this.flightData.flightStatusDetails[this.flightData.flightStatusDetails.length - 1].arrivalAirport.airportCode,
        this.flightData.flightStatusDetails[this.flightData.flightStatusDetails.length - 1].arrivalAirport.airportTerminal
      );
      this._bookingService.updateBookingFlagsCollectionLocation(true);
      this._bookingService.updateBookingFlagsCollectionDateTime(true);

    }
  }

  sendGAManualAddressPageView() {
    ga('set', 'page', '/' + LocationType[this.selectedLocationType] + '/collection-location-details');
    ga('send', 'pageview');
  }

  radioToggleChange(val) {
    this.activeRadioIndex = val;
  }

  callGetLocation(data) {
    this._collectionService.getLocationByProvider(data);
  }
  getGeocode(postcodeInfo) {
    this._geocodeService.getGeocode(postcodeInfo.postcode, postcodeInfo.countryCode);
  }
  selectedGeoCoords(geoCoord) {
    this.residentialGeoCoords = geoCoord;
  }
  updatePrice(postcode) {
    this._priceService.updatePriceLocation(postcode);
  }

  handleShowMenu(value) {
    this.showMenu = value;
  }

  flybackRedirection(dataObj) {
    this.sendToBooking(dataObj);
  }

  sendToBooking(dataObj) {
    const data = JSON.parse(JSON.stringify(dataObj))
    for (const item in data) {
      if (data[item] === null) {
        data[item] = '';
      }
    }

    if (data.type === 8) {
      this._appStore.dispatch(updateIsAirportToAirport({ payload: true }));
    } else {
      this._appStore.dispatch(updateIsAirportToAirport({ payload: false }));
    }
    if (this.selectedLocationType === 4 || this.selectedLocationType === 2) {
      const currentAppState: any = this.getState(this._appStore);
      this.bookingState = currentAppState.bookingReducer;
      const zoneInfo = this.bookingState.bookingDetails.zoneInfo;
      exponea.track('oldfunnel_address', {
        product_direction: this.flightDirection === 1 ? 'abc' : 'ccd',
        zone_name: zoneInfo.zoneId,
        zone_description: zoneInfo.zoneDescription,
        address_city: dataObj.addressTown,
        address_line_1: dataObj.addressLine1,
        address_location_type: dataObj.type,
        address_postcode: dataObj.addressPostCode,
        address_country: dataObj.addressCountry
      });
    }

    if (this.bookingType !== 'amend') {

      const customerAddress = {
        addressLine1: data.addressLine1,
        addressLine2: data.addressLine2,
        addressPostCode: data.addressPostCode,
        addressTown: data.addressTown,
        geoCoord: {
          latitude: data.geoCoord.latitude,
          longitude: data.geoCoord.longitude
        }
      };

      if (this.flightDirection === 1) {
        this._bookingService.updateBookingFlagsCollectionLocation(true);
      } else if (this.flightDirection === 2) {
        this._bookingService.updateBookingFlagsDeliveryLocation(true);
      }

      this._bookingService.updateCollectionOrDeliveryLocation(this.flightDirection, data);
      this._appStore.dispatch(updateCustomerAddress({ payload: customerAddress }));

      this.sendGAManualAddressPageView();
      if(this.flightDirection === 1) {
        this._appStore.dispatch(updateOutboundAddress({ payload: customerAddress }));
      } else {
        this._appStore.dispatch(updateInboundAddress({ payload: customerAddress }));
      }
      // go to next panel...
      this.goPanelForward();
      return;

    } else if (this.bookingType === 'amend') {

      this._bookingService.updateCollectionOrDeliveryLocation(
        this.flightDirection, data);

      const amendData = {
        reference: this._bookingJourneyReference,
        flag: 32
      };
      this._bookingService.postAmend(amendData, true);
      this.goPanelForward();
    }
  }

  cancelLocationAmend(e) {
    this._router.navigate(['my-account/bookings/booking-details'],
      { queryParams: { ref: this.currentBooking.bookingReference } });
  }

  goPanelBack() {
    if (this.isHubdropBooking) {
      const params = this._activatedRoute.parent.snapshot.data['bookingProduct'];
      if(params === 'abc') {
        this._eventsService.goToBookingSwitcher('ccd', 'delivery-time', null, 'falseD2D');
      } else {
        this._eventsService.goToBookingSwitcher('abc', 'collection-post-office', null, 'falseD2D');
      }
    } else if(this.bookingState.bookingDetails.isD2dService) {
      const params = this._activatedRoute.parent.snapshot.data['bookingProduct'];
      if(params === 'abc') {
        this._eventsService.goToBookingSwitcher('ccd', 'delivery-time', null, 'falseD2D');
      } else {
        this._eventsService.goToBookingSwitcher('abc', 'collection-time', null, 'falseD2D');
      }
    } else {
      const redirectToSearch = this.getState(this._appStore).d2dReducer.sessionServiceType;
      if (redirectToSearch) {
        this._router.navigate(['flight-finder/search']);
      } else {
        this._router.navigate(['flight-finder/results']);
      }
    }

    this._appStore.dispatch(selectedServiceType({ payload: '' }));

  }
  goPanelForward() {
    this._eventsService.goToPanel('next');
  };

  getCopy() {
    const panelHeader = this._copyService.getCopyBySection(
      this._bookingCarrier,
      window.location.pathname.split('/')[2],
      ['panelHeader', this.flightDirection === 1 ? 'outbound' : 'inbound']
    );



    const zeroTimeSlot = this._copyService.getCopyBySection(
      this._bookingCarrier,
      window.location.pathname.split('/')[2],
      this.flightDirection === 1 ? ['abc_outbound', 'zeroTimeslots', 'emailScreen'] : ['ccd_inbound', 'zeroTimeslots', 'emailScreen']
    );

    this.appCopy = {
      panelHeader: panelHeader.reduce((acc: any, current, ind) => {
        acc = {...acc, ...current};
        return acc;
      }, {}),

      zeroTimeSlot: zeroTimeSlot[0]
    };
  }



  ngOnDestroy() {
    this._bookingInitSubscription.unsubscribe();
    this._bookingStateSubscription.unsubscribe();

    if (this.bookingInit) {
      this._allAirportsSubscription.unsubscribe();
      this.bookingInit = false;
    }
    if (this._userLanguageSubscription) { this._userLanguageSubscription.unsubscribe() }
    if (this._upsellBookingSubscription) { this._upsellBookingSubscription.unsubscribe() }
    if (this._d2dBookingSubscription) { this._d2dBookingSubscription.unsubscribe() }
    if (this._bookingSubscription) { this._bookingSubscription.unsubscribe(); }
    this._geoCoordsValidationSubscription.unsubscribe();
    this._flybackReducerStateSubscription.unsubscribe();
  }

}
